import React from "react";
import { FlexBox } from "js/react/components/LayoutGrid";
import { WithLabel } from "../../../../Components/WithLabel";
import { ToggleSwitch } from "../../../../Components/ToggleSwitch";
import { withTranslation } from "react-i18next";

const ToggleAllowCommentingComponent = ({ allowCommenting, onToggle, t }) => (
    <FlexBox left middle>
        <WithLabel
            label={t("Allow commenting")}
            toolTip={t("Viewers will be able to view and add comments to the presentation.")}
            gap={20}
        >
            <ToggleSwitch value={allowCommenting} onChange={onToggle} />
        </WithLabel>
    </FlexBox>
);

export const ToggleAllowCommenting = withTranslation()(ToggleAllowCommentingComponent);
